import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TAnnualExchangeRateListResponse,
	TDailyExchangeRateListRequest,
	TDailyExchangeRateListResponse,
	TExchangeRatesStore,
	TEuMonthlyExchangeRateListResponse,
	TGbpMonthlyExchangeRateListResponse,
	TNonEuExchangeRateListResponse,
} from './types';

export const getExchangeRatesState = (state: TStoreState): TExchangeRatesStore =>
	state.exchangeRates;

export const getDailyExchangeRateList = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TDailyExchangeRateListResponse | null =>
		exchangeRates.dailyList,
);

export const getDailyExchangeRateListLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.dailyListLoading,
);

export const getDailyExchangeRateLastListParams = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TDailyExchangeRateListRequest | null =>
		exchangeRates.dailyLastListParams,
);

export const getDailyExchangeRateRefreshLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.dailyRefreshLoading,
);

export const getAnnualExchangeRateList = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TAnnualExchangeRateListResponse | null =>
		exchangeRates.annualList,
);

export const getAnnualExchangeRateListLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.annualListLoading,
);

export const getGbpMonthlyExchangeRateList = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TGbpMonthlyExchangeRateListResponse | null =>
		exchangeRates.gbpMonthlyList,
);

export const getGbpMonthlyExchangeRateListLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.gbpMonthlyListLoading,
);

export const getEuMonthlyExchangeRateList = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TEuMonthlyExchangeRateListResponse | null =>
		exchangeRates.euMonthlyList,
);

export const getEuMonthlyExchangeRateListLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.euMonthlyListLoading,
);

export const getNonEuExchangeRateList = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): TNonEuExchangeRateListResponse | null =>
		exchangeRates.nonEuList,
);

export const getNonEuExchangeRateListLoading = createSelector(
	[getExchangeRatesState],
	(exchangeRates: TExchangeRatesStore): boolean => exchangeRates.nonEuListLoading,
);
